import * as React from "react";
import styled, { css } from "styled-components";

const StyledAlert = styled.div<IStyleProps>`
  padding: 0.75rem 1.25rem;
  border: 1px solid transparent;
  border-radius: 0;
  font-family: ${(props) => props.theme.fonts.base};
  font-size: ${(props) => props.theme.fontSizes[3]};
  font-weight: 500;
  text-align: ${(props) => props.$textAlign};

  @media (min-width: ${({ theme }) => theme.breakpoints[3]}) {
    border-radius: ${(props) => (props.$noRadius ? 0 : props.theme.radii[1])};
  }

  ${(props) =>
    props.type === "error" &&
    css`
      background-color: ${props.theme.colors.accentRed};
      color: ${props.theme.colors.white};
    `}

  ${(props) =>
    props.type === "success" &&
    css`
      background-color: ${props.theme.colors.success};
      color: ${props.theme.colors.white};
    `}

  ${(props) =>
    props.type === "warning" &&
    css`
      background-color: ${props.theme.colors.yellowLight};
      color: ${props.theme.colors.primary};
    `}

  ${(props) =>
    props.type === "info" &&
    css`
      background-color: ${props.theme.colors.primaryTwo};
      color: ${props.theme.colors.white};
    `}

    ${(props) =>
    props.type === "placeholder" &&
    css`
      background-color: ${props.theme.colors.secondaryTwo};
      font-size: ${(props) => props.theme.fontSizes[4]};
      font-weight: 700;
      color: ${props.theme.colors.primary};
    `}

    ${(props) =>
    props.type === "transparent" &&
    css`
      background-color: ${props.theme.colors.white};
      color: ${props.theme.colors.primary};
      text-align: start;
    `}
    
     ${(props) =>
    (props.copnr || props.copnr === 0) &&
    css`
      background-color: ${props.theme.colors.elementStatus[props.copnr].bg};
      color: ${props.theme.colors.elementStatus[props.copnr].color};
    `}
`;

export const AlertItem = styled.p`
  margin-top: ${(props) => props.theme.space[1]};
  margin-bottom: ${(props) => props.theme.space[1]};
  color: currentColor;
`;

export const AlertWrap = styled.div`
  margin: ${(props) => props.theme.space[2]} 0;
`;

export const AlertGroup = styled.div`
  margin-top: ${({ theme }) => theme.space[3]};
  margin-bottom: ${({ theme }) => theme.space[3]};
`;

interface IStyleProps {
  copnr?: number | null;
  type:
    | "error"
    | "success"
    | "warning"
    | "info"
    | "transparent"
    | "placeholder"
    | "news";
  $textAlign?: "start" | "center";
  $noRadius?: boolean;
}

interface IProps extends IStyleProps {
  children: React.ReactNode;
}

const Alert: React.FC<IProps> = ({
  children,
  copnr = null,
  $textAlign = "center",
  type,
  $noRadius = false,
}) => (
  <StyledAlert
    copnr={copnr}
    type={type}
    $textAlign={$textAlign}
    $noRadius={$noRadius}
  >
    {children}
  </StyledAlert>
);

export default Alert;
